<zq-tab-group (currentTabLabelChange)="tabChangeHandler($event)" [currentTabLabel]="currentTab | async"
    [emptyDefault]="true">
    <zq-tab label="zones" name="Zones" [templateRef]="zones">
        <ng-template #zones>
            <zq-tab-group [emptyDefault]="true" [currentTabLabel]="currentSubTab | async"
                (currentTabLabelChange)="subTabChangeHandler($event)">
                <zq-tab label="general" name="General" [templateRef]="zonesGeneral">
                    <ng-template #zonesGeneral>
                        <app-calibration-tabular-import-table [kind]="'general'"
                            [tableType]="tableType.CALIBRATION_GENERAL"
                            [templateType]="'ZONE_COMBINATION_CALIBRATION_GENERAL_VALUES'"
                            [importConfirmationMessage]="'Current zones general values will be imported to Zoning Code. Continue?'"></app-calibration-tabular-import-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="uses" name="Uses" [templateRef]="zonesUses">
                    <ng-template #zonesUses>
                        <app-calibration-uses-values-import-table></app-calibration-uses-values-import-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="parking" name="Parking" [templateRef]="zonesParking" [disabled]="true">
                </zq-tab>
                <zq-tab label="use-capacity" name="Use Capacity" [templateRef]="zonesUseCapacity">
                    <ng-template #zonesUseCapacity>
                        <app-calibration-tabular-import-table [kind]="'useCapacity'"
                            [tableType]="tableType.CALIBRATION_USE_CAPACITY"
                            [templateType]="'ZONE_COMBINATION_CALIBRATION_USE_CAPACITY_VALUES'"
                            [importConfirmationMessage]="'Current zones use capacity values will be imported to Zoning Code. Continue?'"></app-calibration-tabular-import-table>
                    </ng-template>
                </zq-tab>
                <zq-tab label="bonus" name="Bonus" [templateRef]="zonesBonus" [disabled]="true">
                </zq-tab>
                <zq-tab label="building-typology" name="Building Typology" [templateRef]="buildingTypology"
                    [disabled]="true">
                </zq-tab>
            </zq-tab-group>
        </ng-template>
    </zq-tab>
    <zq-tab label="overlays" name="Overlays" [templateRef]="overlays" [disabled]="true">
        <ng-template #overlays>
            <zq-tab-group [emptyDefault]="true" [currentTabLabel]="currentSubTab | async"
                (currentTabLabelChange)="subTabChangeHandler($event)">
                <zq-tab label="general" name="General" [templateRef]="overlayGeneral" [disabled]="true">
                </zq-tab>
                <zq-tab label="uses" name="Uses" [templateRef]="overlayUses" [disabled]="true">
                </zq-tab>
                <zq-tab label="parking" name="Parking" [templateRef]="overlaysParking" [disabled]="true">
                </zq-tab>
                <zq-tab label="use-capacity" name="Use Capacity" [templateRef]="overlaysUseCapacity" [disabled]="true">
                </zq-tab>
                <zq-tab label="bonus" name="Bonus" [templateRef]="zonesBonus" [disabled]="true">
                </zq-tab>
                <zq-tab label="building-typology" name="Building Typology" [templateRef]="buildingTypology"
                    [disabled]="true">
                </zq-tab>
            </zq-tab-group>
        </ng-template>
    </zq-tab>
    <zq-tab label="typologies" name="Typologies" [templateRef]="typologies" [disabled]="true">
        <ng-template #typologies>
            <zq-tab-group [emptyDefault]="true" [currentTabLabel]="currentSubTab | async"
                (currentTabLabelChange)="subTabChangeHandler($event)">
                <zq-tab label="general" name="General" [templateRef]="typologyGeneral" [disabled]="true">
                </zq-tab>
                <zq-tab label="uses" name="Uses" [templateRef]="typologyUses" [disabled]="true">
                </zq-tab>
                <zq-tab label="parking" name="Parking" [templateRef]="typologyParking" [disabled]="true">
                </zq-tab>
                <zq-tab label="use-capacity" name="Use Capacity" [templateRef]="typologyUseCapacity" [disabled]="true">
                </zq-tab>
                <zq-tab label="bonus" name="Bonus" [templateRef]="zonesBonus" [disabled]="true">
                </zq-tab>
            </zq-tab-group>
        </ng-template>
    </zq-tab>
    <zq-tab label="zone-descriptions" name="Zone Descriptions" [templateRef]="zoneDescriptions">
        <ng-template #zoneDescriptions>
            <app-zone-descriptions-import-table></app-zone-descriptions-import-table>
        </ng-template>
    </zq-tab>
    <zq-tab
        label="calibration-set-table-field-attributes"
        name="Calibration Values Attributes"
        [templateRef]="calibrationSetTableFieldAttributes">
        <ng-template #calibrationSetTableFieldAttributes>
            <app-calibration-set-table-field-attributes-import-table></app-calibration-set-table-field-attributes-import-table>
        </ng-template>
    </zq-tab>
</zq-tab-group>
